export enum FeedbackType {
    General = 'general',
    Support = 'support',
    AppBug = 'app-bug',
    FormBug = 'form-bug',
    AppFeature = 'app-feature',
    FormFeature = 'form-feature'
}
